import { api, unwrap, v4 as uuid } from '@saas-kit/lib';

export interface BellNotification {
  id: string;
  kind: string;
  channel: string;
  status: string;
  title: string;
  body: string;
  payload: Record<string, unknown>;
  created_at: string;
  read_at: string | null;
}

interface ListEnvelope {
  data: { items: BellNotification[] };
  meta: { page?: { total: number; offset: number; limit: number } };
}

export async function fetchUnreadCount(): Promise<number> {
  const r = await unwrap<{ count: number }>(
    api.get('/notifications/unread-count'),
  );
  return r.count;
}

export async function fetchLatestNotifications(
  limit = 20,
): Promise<BellNotification[]> {
  const resp = await api.get<ListEnvelope>(`/notifications?limit=${limit}`);
  return resp.data.data.items;
}

export async function markNotificationRead(id: string): Promise<void> {
  await api.post(
    `/notifications/${id}/read`,
    {},
    { headers: { 'Idempotency-Key': uuid() } },
  );
}

export async function markAllNotificationsRead(): Promise<number> {
  const r = await unwrap<{ updated: number }>(
    api.post(
      '/notifications/read-all',
      {},
      { headers: { 'Idempotency-Key': uuid() } },
    ),
  );
  return r.updated;
}
